export default "__VITE_ASSET__CjPLuNCV__"